import React, { useState, useEffect } from 'react'
import { CreateGroupDto, UpdateGroupDto } from '@/types'
import { Modal } from '@/components/ui/Modal'
import { Input } from '@/components/ui/Input'
import { useGroupsStore } from '@/stores/groups.store'
import { toastError, toastSuccess } from '@/utils/toast'

interface GroupFormModalProps {
  group: { _id: string; name: string } | null
  onClose: () => void
  onSuccess: () => void
}

export const GroupFormModal: React.FC<GroupFormModalProps> = ({ group, onClose, onSuccess }) => {
  const addGroup = useGroupsStore(state => state.addGroup)
  const updateGroup = useGroupsStore(state => state.updateGroup)

  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (group) {
      setName(group.name)
    }
  }, [group])

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError('Le nom du groupe est requis')
      return
    }

    setLoading(true)
    setError('')

    try {
      if (group) {
        await updateGroup(group._id, { name } as UpdateGroupDto)
        toastSuccess('Groupe modifié avec succès')
      } else {
        await addGroup({ name } as CreateGroupDto)
        toastSuccess('Groupe créé avec succès')
      }
      onSuccess()
    } catch (error: unknown) {
      const errorMessage =
        error instanceof Error ? error.message : "Erreur lors de l'enregistrement du groupe"
      setError(errorMessage)
      toastError(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={group ? 'Modifier le groupe' : 'Nouveau groupe'}
      confirmButtonText={group ? 'Modifier' : 'Créer'}
      onCancel={onClose}
      onConfirm={handleSubmit}
      isLoading={loading}
      size="sm"
    >
      <form
        onSubmit={e => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        <Input
          label="Nom du groupe"
          type="text"
          value={name}
          onChange={e => {
            setName(e.target.value)
            setError('')
          }}
          error={error}
          placeholder="Entrez le nom du groupe"
          required
        />
      </form>
    </Modal>
  )
}
